<template>
  <!--使用elementui的table如下,速度较慢-->
  <div>
    <div v-if="isShowTotalNumber" style="text-align:right;font-size:12px;">总数：{{totalnumber}}</div>
    <el-table
      :data="showErweitable(true)" v-if="needtwo"
      :height="geterwtableHeight()" border :header-cell-class-name="'twodimensionalcellheader'"
      :cell-class-name="cellClassName"
      size="mini" style="width: 48%;float: left;">
      <el-table-column fixed
                       width="50"
                       label="球\柱"
                       align="center">
        <template slot-scope="scope">
          {{(scope.row[0].Y > 0 ? "+" : "" ) + scope.row[0].Y.toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column v-for="(item,xindex) in zhujing" :key="item"
                       :label="(item > 0 ? '+' : '')+item.toFixed(2)"
                       align="right" width="40" header-align="center">
        <template slot-scope="scope">
          <a  :title="'S：'+scope.row[xindex].Y.toFixed(2)+' ， C：'+scope.row[xindex].X.toFixed(2)">{{scope.row[xindex].P}}</a>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="showErweitable(false)"
      :height="geterwtableHeight()" border :header-cell-class-name="'twodimensionalcellheader'"
      :cell-class-name="cellClassName"
      size="mini"
      :style="{width: needtwo?'48%':'100%'}" style="float: left;">
      <el-table-column fixed
                       width="50"
                       label="球\柱"
                       align="center">
        <template slot-scope="scope">
          {{(scope.row[0].Y > 0 ? "+" : "" ) + scope.row[0].Y.toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column v-for="(item,xindex) in zhujing" :key="item"
                       :label="(item > 0 ? '+' : '')+item.toFixed(2)"
                       align="right" width="40" header-align="center">
        <template slot-scope="scope">
          <a  :title="'S：'+scope.row[xindex].Y.toFixed(2)+' ， C：'+scope.row[xindex].X.toFixed(2)">{{scope.row[xindex].P}}</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {saveData, getDetail, getControlData} from '@/api/set/goodsprice';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        defaultValue: "",
        zhujing: [],
        needtwo:false,
        qiujing: [],
        erweitable: [],
        form: {  //表单数据

        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。

        },
      }
    },
    props: {
      initContent: {
        type: Array,
        default: () => []
      },
      cutHeight: {
        default: 245
      },
      needSetHeight: {
        default: true
      },
      isShowTotalNumber: {//是否显示总数，价格设置、最大最小库存设置时需要设置成false
        default: true
      }
    },
    methods: {
      showErweitable(plus) {
        if(!this.needtwo)
          return this.erweitable;
        const newTable = [];
        if (plus) {//只显示Y正数
          for (let i in this.erweitable) {
            if (this.erweitable[i].length == 0) continue;
            if (this.erweitable[i][0].Y > 0)
              newTable.splice(0,0,this.erweitable[i]);
          }
        } else {
          for (let i in this.erweitable) {
            if (this.erweitable[i].length == 0) continue;
            if (this.erweitable[i][0].Y <= 0)
              newTable.push(this.erweitable[i]);

          }
        }
        return newTable;
      },
      renderYdataWithInitData(i, initdata) {
        this.qiujing.push(i)
        let arr = []
        for (let j in this.zhujing) {
          var temp = initdata.filter((item) => {
            return item.X == this.zhujing[j] && item.Y == i;
          })
          arr.push({P: temp.length > 0 ? temp[0].P : "", X: this.zhujing[j], Y: i})
        }
        this.erweitable.push(arr)
      },
      cellClassName(data) {
        if (data.columnIndex == 0)
          return 'twodimensionalcellheader';
        else
          return 'twodimensionalcelltd1';
      },
      geterwtableHeight() {
        if (!this.needSetHeight) {
          return null
        }
        return this.dialogtableHeight(this.cutHeight);
      },
      //简化显示内容 initbook=XY的范围  bookContent=最终的内容
      initBookFix() {
        var bookContent = this.initContent;
        this.erweitable.splice(0, this.erweitable.length)
        //生成柱镜
        this.zhujing = []
        //生成球镜
        this.qiujing = []

        this.needtwo = false;
        var qiujingArea = []
        for (var bookC in bookContent) {
          var XV = Number(bookContent[bookC].X);
          bookContent[bookC].X = XV;
          var YV = Number(bookContent[bookC].Y);
          if(YV>0&&!this.needtwo)
            this.needtwo = true;
          bookContent[bookC].Y = YV;
          var temp = this.zhujing.filter((item) => {
            return item == XV;
          })
          if (temp.length == 0)
            this.zhujing.push(XV)

          temp = qiujingArea.filter((item) => {
            return item == YV;
          })
          if (temp.length == 0)
            qiujingArea.push(YV)
        }

        this.zhujing.sort(this.sequence);
        qiujingArea.sort(this.sequence);

        for (var i in qiujingArea) {
          this.renderYdataWithInitData(qiujingArea[i], bookContent)
        }
      },
      sequence(a, b) {//从大到小排列
        if (a > b) {
          return -1;
        } else if (a < b) {
          return 1
        } else {
          return 0;
        }
      }
    },
    computed: {
      totalnumber() {
        let s = 0;
        this.erweitable.forEach(o => {
          o.forEach(o2 => {
            if (o2.P)
              s += parseFloat(o2.P)
          })
        })
        return s
      }
    },
    mounted() {
      this.initBookFix();
    },
    components: {},
  }
</script>

<style scoped>
  .erweitable td {
    border: 1px solid #000000;
    min-width: 50px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }

</style>

<style>
  .twodimensionalcellheader {
    background-color: #fffdef !important;
    padding: 3px 0 !important;
    font-weight: normal;
    font-size: 12px;
  }

  .twodimensionalcelltd1 .cell, .twodimensionalcellheader .cell {
    padding-left: 3px !important;
    padding-right: 3px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/goodsprice/TwoDimensionalView.vue